<template>
  <div class="row selectiontext" v-show="false">
    <div class="col-lg-4 mb-2">
      <router-link
        :to="{ name: 'SelectQueue' }"
        tag="div"
        class="whitebox m-0 cajaresumen "
        role="button"
        v-if="queue"
      >
        <div class="row">
          <div class="col-1 text-center">
            <i class="fa fa-building"></i>
          </div>
          <div class="col-11" v-html="queue"></div>
        </div>


      </router-link>
    </div>

    <div class="col-lg-4 mb-2">
      <router-link
        :to="{ name: 'SelectService' }"
        tag="div"
        class="whitebox m-0 cajaresumen "
        role="button"
        v-if="service"
      >

        <div class="row">
          <div class="col-1 text-center">
            <i class="fa fa-list"></i>
          </div>
          <div class="col-11">
            <span v-html="service"></span>
            <br/>
            <span v-html="channel || '<br/> ' "></span>
          </div>
        </div>

      </router-link>
    </div>
    <div class="col-lg-4 mb-2">
      <router-link
        :to="{ name: 'PersonalData' }"
        tag="div"
        class="whitebox m-0 cajaresumen "
        role="button"
        v-if="(visitor ||{}).visitorVatID"
      >


        <div class="row">
          <div class="col-1 text-center">
            <i class="fa fa-male"></i>
          </div>
          <div class="col-11">
            {{ visitor.visitorVatID }} - {{ visitor.visitorName }} {{ visitor.visitorFamilyName }}
            <br/>
            <span v-html="visitor.visitorEmail || '<br/> ' "></span>
          </div>
        </div>
      </router-link>
    </div>
  </div>
</template>

<script>
import Session from "@/session/Session.js";

export default {
  name: "DatosIntroducidos",
  components: {},
  props: {
    titulo: String,
    descripcion: String,
  },
  data: () => ({
    Session,
  }),
  computed: {
    queue() {
      let q = Session.getQueue();
      return q ? q.name : null;
    },
    service() {
      let q = Session.getServicePoint();
      return q ? q.name : null;
    },
    channel() {
      let q = Session.getServiceChannel();
      return q ? q.name : null;
    },
    visitor() {
      return Session.getVisitor();
    },
  },
};
</script>

<style scoped>
.selectiontext {
  font-size: 70%;
  margin-bottom: 0;
}

.cajaresumen {
  min-height: 4rem;
  /* border: 2px solid #37474f; */
}
</style>

